module.exports = __webpack_public_path__ + "static/media/Groupcar.b4249bd6.svg";